import { JobStatus } from '@/api/generatedApi';
import { ApiErrorAlert } from '@/components/Errors/ApiErrorAlert';
import { GeneratingReport } from '@/components/Report/GeneratingReport';
import { ReportContent } from '@/components/Report/ReportContent';
import { useGetReport } from '@/hooks/api/reports/useGetReport';
import { usePageTitle } from '@/hooks/usePageTitle';
import { getApiError } from '@/types/apiError';
import { Box, styled } from '@mui/material';
import { useParams } from 'react-router-dom';

const PageWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  minWidth: 0,
  overflow: 'hidden',
});

export const ReportDetailPage = () => {
  const { id } = useParams();
  const { report, error, refetch } = useGetReport({ id });
  usePageTitle(report?.name || 'Report');

  return (
    <PageWrapper>
      {error && <ApiErrorAlert error={getApiError(error, 'Failed to load report')} />}
      {report && report.status === JobStatus.COMPLETED && <ReportContent />}
      {report && [JobStatus.PENDING, JobStatus.RUNNING].includes(report.status) && (
        <GeneratingReport report={report} refetch={refetch} error={error} />
      )}
    </PageWrapper>
  );
};
